import { IOmniSearchApplication } from "@studyportals/omnisearch-interfaces/application/IOmniSearchApplication";
import { FilterType } from "@studyportals/omnisearch-interfaces";
import { useSearchStore } from "@stores/useSearchStore";
import { FilterProcessingService } from "@app/routing/FilterProcessingService";
import { getPortalTypeFromEnvClient } from "@utils/get-portal-type-from-env.client";

export class OmniSearchApplication implements IOmniSearchApplication {
	private filterProcessingService: FilterProcessingService;

	constructor() {
		this.filterProcessingService = FilterProcessingService.getInstance();
	}

	public getFilter(type: FilterType): string[] {
		const store = useSearchStore();
		return store.filtersSelection.filter(f => f.type === type).flatMap(f => f.values.map(v => v.id));
	}

	public async setFilters(filters: Record<FilterType, string[]>): Promise<void> {
		const addedFilterTypes = Object.keys(filters) as FilterType[];
		const mandatoryFilters = this.getMandatoryFilterTypes();

		if(addedFilterTypes.some(type => mandatoryFilters.includes(type))) throw new Error('Cannot set mandatory filters');

		const newFiltersSelection = Object.entries(filters).map(([type, values]) => {
			const extendedValues = this.filterProcessingService.translateValuesToExtendedFilters(type as FilterType, values);
			return { type: type as FilterType, values: extendedValues };
		});

		const store = useSearchStore();
		store.filtersSelection = [
			...store.filtersSelection.filter(f => mandatoryFilters.includes(f.type)),
			...newFiltersSelection
		];

		await store.setRouteAndLoadData();
	}

	private getMandatoryFilterTypes(): FilterType[] {
		const mappers = [];

		for(const mapper of this.filterProcessingService.mappers){
			if(!mapper.isMandatory(getPortalTypeFromEnvClient())) continue;
			mappers.push(mapper.filterType);
		}

		return mappers;
	}

}